import { styled } from '@mui/system';

export const RiskStyles = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
`;

export const DescStyles = styled('div')`
    margin: 16px 0 16px 0;
`;
